import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SortableHeaderProps {
  label: string;
  sortKey: string;
  currentSortKey?: string;
  sortDirection?: 1 | -1;
  onSort: (key: string) => void;
}

/**
 * Sortable column header (ghost button, up/down arrow indicator).
 * See atek-frontend-layout style-guide §3.6.
 */
export function SortableHeader({
  label,
  sortKey,
  currentSortKey,
  sortDirection,
  onSort,
}: SortableHeaderProps) {
  const isActive = currentSortKey === sortKey;
  return (
    <Button
      variant="ghost"
      size="sm"
      className="-ml-3 h-8 hover:bg-transparent"
      onClick={() => onSort(sortKey)}
    >
      {label}
      {isActive ? (
        sortDirection === 1
          ? <ArrowUp className="ml-1 h-3 w-3" />
          : <ArrowDown className="ml-1 h-3 w-3" />
      ) : (
        <ArrowUpDown className="ml-1 h-3 w-3 opacity-50" />
      )}
    </Button>
  );
}
